import svg from './row-svg/loupe.svg';
import { FixMe } from '@greenkub-fronts/shared/interface';

export function LoupeIcon(props: FixMe) {
  return <img {...props} src={svg} alt="svg" />;
}

export default LoupeIcon;
